import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactService } from '../../shared/services/static-page/contact.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contactService: ContactService
  ) {}
  contact: any;
  locationLink: any;

  async ngOnInit(): Promise<void> {
      let data = await firstValueFrom(this.contactService.getContact());
      this.contact = data[0];
      const regex = /src="([^"]*)"/;
      const match = this.contact.locationLink.match(regex);
      this.locationLink = match ? match[1] : null;
  }
}
